import React, { useEffect, useState } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Flag from "react-world-flags";
import { newsData } from "../nyheder/News";
import ScrollToTop from "./Tiltop";
import '../css/Home.css';
import {
  FaChalkboardTeacher,
  FaUsers,
  FaTrophy,
  FaDumbbell,
  FaGamepad,
  FaUserPlus,
  FaGift,
  FaCreditCard,
  FaBrain,
  FaChess,
  FaComments,
  FaUserTie,
  FaShieldAlt,
  FaFire,
  FaTwitter,
} from "react-icons/fa";


export default function Home() {
  const upcomingEvents = newsData
    .filter((n) => n.category === "Event")
    .sort((a, b) => new Date(a.date) - new Date(b.date));
  const nextEvent = upcomingEvents[0];

  const [selectedGame, setSelectedGame] = useState("cs2");
  const [selectedCoachGame, setSelectedCoachGame] = useState("cs2");
  const navigate = useNavigate();

  // === SPIL ===
  const games = [
  {
  id: "cs2",
  slug: "cs2",
  name: "Counter-Strike 2",
  icon: (
    <img
      src="/cs2.png"
      alt="Counter-Strike 2"
      className="icon"
    />
  ),
  description:
    "ræn præcision, strategi og kommunikation, lær teamwork og samarbejd for at vinde som et hold.",
  },
  {
  id: "valorant",
  slug: "valorant",
  name: "valorant",
  icon: (
    <img
      src="/valobanner.png"
      alt="valorant"
      className="icon"
    />
  ),
  description:
    "Lær taktiske færdigheder, skarp skydning og evner, udvikl teamwork og koordinering på højt niveau.",
  },
  {
  id: "lol",
  slug: "lol",
  name: "League of Legends",
  icon: (
    <img
      src="/lolbanner.png"
      alt="League of Legends"
      className="icon"
    />
  ),
  description:
    "Forstå rollefordeling, strategi og samarbejde, træd ind i konkurrencer og udvikl spilforståelse.",
  },
  {
  id: "fortnite",
  slug: "fortnite",
  name: "Fortnite",
  icon: (
    <img
      src="/fortnitbanner.png"
      alt="Fortnite"
      className="icon"
    />
  ),
  description:
    "Lær hurtige beslutninger, byggestrategi og samarbejde i actionfyldte kampe.",
  },
  {
  id: "pubg",
  slug: "pubg",
  name: "Battlegrounds",
  icon: (
    <img
      src="/pubgbanner.png"
      alt="Battlegrounds"
      className="icon"
    />
  ),
  description:
    "Lær hurtige beslutninger, byggestrategi og samarbejde i actionfyldte kampe.",
  },
  {
  id: "tft",
  slug: "tft",
  name: "Team fight tactics",
  icon: (
    <img
      src="/tftbanner.png"
      alt="Team fight tactics"
      className="icon"
    />
  ),
  description:
    "Udvikl strategisk tænkning, placering og beslutningsevner i holdbaserede kampe.",
  },
  {
  id: "fifa",
  slug: "fifa",
  name: "FIFA 25",
  icon: (
    <img
      src="/fifabanner.png"
      alt="FIFA 25"
      className="icon"
    />
  ),
  description:
    "Træn holdspil, taktik og koordination, lær at samarbejde på banen og forbedre spilforståelse.",
  },
  {
  id: "robloxminecraft",
  slug: "robloxminecraft",
  name: "Roblox / Minecraft",
  icon: (
    <img
      src="/Roblox-minecraft.png"
      alt="Roblox / Minecraft"
      className="icon"
    />
  ),
  description:
    "Kreativitet, samarbejde og problemløsning, lær at bygge, planlægge og spille sammen i fællesskab.",
  },
  ];

  // === TRÆNERE ===
  const coaches = [
    {
      id: 1,
      game: "cs2",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
    {
      id: 2,
      game: "valorant",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
    {
      id: 3,
      game: "lol",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
        {
      id: 4,
      game: "fortnite",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
        {
      id: 5,
      game: "pubg",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
        {
      id: 6,
      game: "tft",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
    {
      id: 7,
      game: "fifa",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },        
    {    
      id: 8,
      game: "robloxminecraft",
      name: "Mathias Carlsen",
      ingame: "escilea",
      flag: "DK",
      img: "/under1.png",
      social: {
        twitter: "https://x.com/escilea111",
      },
    },
  ];







  const filteredCoaches = coaches.filter(
    (coach) => coach.game === selectedCoachGame
  );

 const heroImages = [
  "/open.jpeg",
  "/open.jpeg",
  "/open.jpeg",
  "/open.jpeg",
  "/open.jpeg",
 ];


 const [current, setCurrent] = useState(0);
 useEffect(() => {
  const interval = setInterval(() => {
    setCurrent((prev) => (prev + 1) % heroImages.length);
  }, 5000);

  return () => clearInterval(interval);
 }, [heroImages.length]);


const [events, setEvents] = useState([]);
useEffect(() => {
  const fetchUserEvents = async () => {
    try {
      const userId = 1; 
      const userRes = await axios.get(`/api/users/${userId}`);
      const teamId = userRes.data.team_id;

      const eventsRes = await axios.get(`/api/events?team_id=${teamId}`);
      const teamEvents = eventsRes.data.map((ev) => ({
        title: ev.titel,
        start: ev.start,
        end: ev.slut,
      }));

      setEvents(teamEvents);
    } catch (error) {
      console.error("Fejl ved hentning af events:", error);
    }
  };

  fetchUserEvents();
}, []); 









  return (
    <div className="academy-page">
<section className="hero-grid">
  {/* Venstre kolonne: slideshow */}
  <div className="hero-left">
    {heroImages.map((img, index) => (
      <img
        key={img}
        src={img}
        alt="Linx Legacy Academy"
        className={`hero-slide ${index === current ? "active" : ""}`}
      />
    ))}
  </div>

  {/* Højre kolonne: tekst + knapper + features */}
  <div className="hero-right">
    <div className="hero-content">
      <p>Linx Legacy Academy</p>
      <h1>Esport på Frederiksberg</h1>
      <p>
        Kombinerer vi gaming, fællesskab og udvikling 
        her lærer du ikke bare at spille, men at samarbejde, vokse og spille som et hold.
      </p>
      <div className="hero-buttons">
        <a href="/Gametime" className="btn primary">
          Se holdtider 
        </a>
        <a href="/Gamespage" className="btn second">
          Spil vi tilbyder
        </a>
      </div>
    </div>

    <div className="features">
      <div className="feature-box">
        <FaChalkboardTeacher className="icon" />
        <p>Professionel Træning</p>
      </div>
      <div className="feature-box">
        <FaUsers className="icon" />
        <p>Stærkt Fællesskab</p>
      </div>
      <div className="feature-box">
        <FaTrophy className="icon" />
        <p>Konkurrencer & Events</p>
      </div>
      <div className="feature-box">
        <FaDumbbell className="icon" />
        <p>Trivsel & Sundhed</p>
      </div>
    </div>
  </div>
</section>





      <section className="schedule-opdel">
        <div className="schedule-left">
          <h2>Bliv en del af fællskabet</h2>
          <p>
            Hos <span className="gold">Linx Legacy Academy</span> handler
            undervisningen om dig. Uanset om du gamer for sjov eller drømmer om at
            spille på de store scener. Så finder vi sammen den rette vej.<br/>
          </p>
          <p>
          Os hos er gaming mere end gaming - det er et fællesskab, 
          en passion og en personlig udvikling. 
          Vi tror på, at alle har potentialet til at vokse og trives gennem gaming, 
          og vi er her for at støtte dig på den rejse. 
          <br/>
          Derfor tager vi også en personlig snak med alle nye medlemmer, for at finde det rette hold og træning for dig.
          </p>
          <p>
          Du kan træne i vores lokaler på Frederiksberg, eller online hjemmefra. <br/>
          Det koster 2000kr i kontigent per 6 måned.
          </p>

        </div>


        <div className="schedule-right">
          <h2>Opdeling af niveau på holdene</h2>
          <p>
            Vi opdeler holdene ud fra niveau og ambitioner.
            Dette gør vi for at sikre at alle får den bedst mulige oplevelse og udvikling, 
            uanset om du er nybegynder eller har spillet i mange år.
          </p>
        </div>
        </section>


      <section className="about-section">
        <h2 className="section-title">Mere end gaming</h2>
        <p className="about-text">
          Er ikke kun et moto det er en filosofi. Vi tror på, at gaming kan være en vej til personlig udvikling,
          fællesskab og succes, både i spillet og i livet. Derfor tilbyder vi mere end bare træning. 
          Vi skaber et miljø, hvor du kan vokse som gamer og som person.
        </p>
        <div className="why-mini-grid">
          <div className="why-mini-item">
            <FaUsers className="icon" />
            <p>Fællesskab</p>
          </div>
          <div className="why-mini-item">
            <FaChalkboardTeacher className="icon" />
            <p>Coaching & Træning</p>
          </div>
          <div className="why-mini-item">
            <FaTrophy className="icon" />
            <p>Konkurrence & Events</p>
          </div>
          <div className="why-mini-item">
            <FaDumbbell className="icon" />
            <p>Fysisk Sundhed</p>
          </div>
          <div className="why-mini-item">
            <FaBrain className="icon" />
            <p>Kognitiv Performance</p>
          </div>
          <div className="why-mini-item">
            <FaChess className="icon" />
            <p>Strategi & Spilforståelse</p>
          </div>
          <div className="why-mini-item">
            <FaComments className="icon" />
            <p>Kommunikation & Samarbejde</p>
          </div>
          <div className="why-mini-item">
            <FaUserTie className="icon" />
            <p>Personlig Udvikling</p>
          </div>
          <div className="why-mini-item">
            <FaShieldAlt className="icon" />
            <p>Digitale Dannelse</p>
          </div>
          <div className="why-mini-item">
            <FaFire className="icon" />
            <p>Motivation & Mentalitet</p>
          </div>
        </div>
      </section>




      
{/* ================= Sådan kommer du i gang ================= */}
<section className="academy-flow">
  <h2>Sådan kommer du i gang</h2>

  <div className="flow-grid">
    <div className="card ">
      <FaGamepad className="icons" />
      <h4>Vælg dit favoritspil</h4>
    </div>
    <div className="card ">
      <FaUserPlus className="icons" />
      <h4>Tilmeld dig Academy</h4>
    </div>
    <div className="card ">
      <FaGift className="icons" />
      <h4>Gratis prøvetime</h4>
    </div>
    <div className="card ">
      <FaCreditCard className="icons" />
      <h4>Aktiver dit medlemskab</h4>
    </div>
  </div>

<div className="games-section">
  {/* GAMES */}
  <div className="flow-grid games">
    {games.map((game) => (
      <div
        key={game.id}
        className={`card game-item ${
          selectedGame === game.id ? "selected" : ""
        }`}
        onClick={() => setSelectedGame(game.id)}
      >
     <div className="game-item-content">
     {game.icon}
     <p>{game.name}</p>
     </div>
    </div>
    ))}
  </div>

  {/* GAME DETAILS */}
  <div className="game-details">
    {games
      .filter((g) => g.id === selectedGame)
      .map((game) => (
        <div key={game.id}>
          <h3>{game.name}</h3>
          <p>{game.description}</p>
<button
  className="card-button"
  onClick={() =>
    navigate("/Gametime", { state: { selectedGame: game.slug } })
  }
>
  Se holdtider
</button>
        </div>
      ))}
  </div>
</div>
</section>


    {/* === MØD TRÆNERNE === */}
      <section className="coaches">
        <h2 className="section-heading">Mød vores trænere</h2>
        <div className="game-filter">
          {games.map((game) => (
            <button
              key={game.id}
              className={`fil-btn ${
                selectedCoachGame === game.id ? "active" : ""
              }`}
              onClick={() => setSelectedCoachGame(game.id)}
            >
            <div className="game-item-content">
            {game.icon}
            <p>{game.name}</p>
            </div>
            </button>
          ))}
        </div>
       <div className="coach-list">
  {filteredCoaches.map((coach) => (
    <div key={coach.id} className="coach-card">
      <h4>{coach.name}</h4>
      <img src={coach.img} alt={coach.name} className="coach-img" />
      <p className="coach-ingame">{coach.ingame}</p>
      <div className="coach-info-row">
        <Flag country={coach.flag} size={20} />
        <div className="coach-socials">
          {/* Twitter */}
          {coach.social?.twitter && (
            <a
              href={coach.social.twitter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter className="twitter" />
            </a>
          )}
        </div>
      </div>
    </div>
  ))}
</div>
</section>




{/* ================= KALENDER ================= */}
<section className="schedule">
  <div className="schedule-midt">
    <section className="front-calendar">
      <div className="calendar-container">
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          events={events}
        />
      </div>
    </section>
  </div>
</section>





  
      <ScrollToTop />
    </div>
  );
}
